import { Image, Button } from "rsuite";
import { BUTTON_BLUE, BUTTON_GREEN, BUTTON_RED } from "../../utils/constants/images";
import logger from "../../utils/logger";
import "./button.css";

function BestStartButton({ text, content, color, width = 100, height = 50, onClick = () => {logger.warn('no click handler attached!')}, className = '', appearance='primary', "data-testid": dataTestId, ...props }) {
  const buttonContent = content ?? text;
  const accessibleLabel = props["aria-label"] ?? text;

  return (
    <Button data-testid={`${dataTestId}-container`} className={`best-start-button ${className}`} style={{ width: width, height: height }} appearance={appearance} onClick={onClick} {...props}>
      <Image
        data-testid={dataTestId}
        fit="fill"
        width={width}
        height={height}
        src={color === "blue" ? BUTTON_BLUE : color === "red" ? BUTTON_RED : BUTTON_GREEN}
        alt={accessibleLabel}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      />
      <span
        className="best-start-button-content"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: -2,
          transform: "translate(-50%, -50%)",
        }}
      >
        {buttonContent}
      </span>
    </Button>
  );
}

export default BestStartButton;
